/*
 * TUMLE: keeps the product badges bottom left on the main image that is
 * showing, --badge-inset from its left edge and --badge-inset-bottom from its
 * bottom edge.
 * The image is contained inside its slide and may be narrower than the
 * gallery (desktop), so the position is measured from the image itself.
 * Without JS the CSS fallback places the badges bottom left of the gallery.
 */
if (!customElements.get('tumle_image-badges')) {
  customElements.define(
    'tumle_image-badges',
    class TumleImageBadges extends HTMLElement {
      connectedCallback() {
        this.viewer = this.closest('[id^="GalleryViewer"]');
        this.list = this.viewer?.querySelector('[id^="Slider-Gallery"]');
        if (!this.list) return;

        this.queued = false;
        const update = () => this.queue();
        this.list.addEventListener('scroll', update, { passive: true });
        this.list.addEventListener('load', update, true);
        window.addEventListener('resize', update);
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.viewer);
        // Thumbnail clicks and variant changes move the is-active class
        this.mutationObserver = new MutationObserver(update);
        this.mutationObserver.observe(this.list, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
        this.queue();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }

      queue() {
        if (this.queued) return;
        this.queued = true;
        requestAnimationFrame(() => {
          this.queued = false;
          this.place();
        });
      }

      // The slide showing now: the visible one nearest the viewer's left edge
      currentSlide() {
        const viewerLeft = this.viewer.getBoundingClientRect().left;
        let best = null;
        let bestDistance = Infinity;
        this.list.querySelectorAll(':scope > li').forEach((slide) => {
          const rect = slide.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          const distance = Math.abs(rect.left - viewerLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = slide;
          }
        });
        return best;
      }

      place() {
        const slide = this.currentSlide();
        const image = slide?.querySelector('.product__media img, img');
        if (!image) return;
        const imageRect = image.getBoundingClientRect();
        if (!imageRect.width) return;
        const slideRect = slide.getBoundingClientRect();
        const viewerRect = this.viewer.getBoundingClientRect();
        const inset = parseFloat(getComputedStyle(this).getPropertyValue('--badge-inset')) || 16;
        const insetBottom = parseFloat(getComputedStyle(this).getPropertyValue('--badge-inset-bottom')) || inset;
        // Horizontal: the image's inset inside its own slide, which starts at
        // the viewer's left edge once settled; measuring within the slide keeps
        // a swipe in progress from dragging the badges along.
        // Vertical: straight from the image.
        const left = Math.max(imageRect.left - slideRect.left, 0) + inset;
        const bottom = Math.max(viewerRect.bottom - imageRect.bottom, 0) + insetBottom;
        this.style.left = `${Math.round(left)}px`;
        this.style.bottom = `${Math.round(bottom)}px`;
      }
    }
  );
}
